import "./filters.css";
import { useState, useRef } from "react";
import Input from "../formBasic/Input";
import SearchFilterIcon from "../../../assets/svgs/searchFilter.svg";
import Filter from "../../../assets/img/filter.png";
import LixoIcon from "../../../assets/svgs/lixo.svg";
import IconAlert from "../../../assets/svgs/icon-alert.svg";
import ContainerError from "../../error/containerError";
import { getUserApprover, getUserEngInternals } from "../../../redux/actions/fluxoNSimilar";
import { useDispatch } from "react-redux";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import { BaseFilterPage } from "../../../types/filterPage";
import { useRoles } from "../../../hooks/roles";
import { AppDispatch } from "../../../redux/store";

export interface FilterPageDash extends BaseFilterPage {}

const FiltersAprovador = ({
  handleFilter,
  emitentePartNumber,
  setEmitentePartDesc,
}: FilterPageDash) => {
  const dispatch = useDispatch<AppDispatch>();
  const [emitenteDescError, setEmitenteDescError] = useState("");
  const MAX_LENGTH = 49;

  const emailInputRef = useRef<HTMLInputElement>(null);
  
  const { isTax } = useRoles();

  const clearFilters = async () => {
    setEmitentePartDesc("");

    await dispatch(isTax ? getUserApprover({}) : getUserEngInternals({}));
  };

  const isFilterButtonDisabled = !emitentePartNumber;

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value.length >= MAX_LENGTH) {
      setEmitenteDescError("Limite de 50 caracteres atingido.");
    } else {
      setEmitenteDescError("");
    }
    setEmitentePartDesc(value);
  };

  return (
    <div className="containerFilters">
      <div>
        <Input
          id="material-part-desc"
          label=""
          placeholder="E-mail"
          img={SearchFilterIcon}
          value={emitentePartNumber}
          onChange={handleEmailChange}
          aria-describedby="E-mail"
          inputRef={emailInputRef}
          maxLength={50}
        />

        {emitenteDescError && (
          <ContainerError
            id="material-part-desc-error containerErro"
            label={emitenteDescError}
            icon={IconAlert}
            backgroudError={"#D1E4FF"}
            widthError=""
            colorError={"#000000"}
          />
        )}
      </div>

      <div style={{ display: "flex", marginTop: 3 }}>
        {handleFilter && (
          <ButtonGeneric
            img={Filter}
            title="Aplicar filtros"
            colorTitle="#FFFFFF"
            background=""
            style="buttonHeading"
            onClick={() => {
              handleFilter();
            }}
            disabled={isFilterButtonDisabled}
          />
        )}

        <div style={{ marginLeft: 10 }}>
          <ButtonGeneric
            img={LixoIcon}
            title="Limpar filtros"
            colorTitle="#007BC0"
            background=""
            style="buttonLixo"
            onClick={() => {
              clearFilters();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FiltersAprovador;
